import { AutoComplete } from "antd";
import React, { useMemo, useState } from "react";
import { useApi } from "../../../../../hooks/http2";
import _, { debounce } from "lodash";

const ProductSearch = ({ onSelect, ...props }) => {
  const [value, setValue] = useState("");
  const [search, setSearch] = useState("");

  const debounceSearch = useMemo(() => debounce(setSearch, 500), []);

  const _list = useApi(
    {
      url: `/marketing/hard-promotion/products`,
      params: { search },
      token: true,
      initialLoad: search.length >= 3,
    },
    [search]
  );

  const options = (item) => {
    return (
      <AutoComplete.Option key={item.product_code} value={item.product_code} label={item.product_name_en}>
        <span>
          <strong className="mr-1">{item.product_code}</strong>
          <small>{item.product_name_en}</small>
        </span>
      </AutoComplete.Option>
    );
  };

  return (
    <AutoComplete
      placeholder="ค้นหาด้วยรหัสสินค้า ชื่อสินค้า"
      className="w-100"
      dataSource={_.map(_list.fetch || [], options)}
      value={value}
      onChange={(value) => setValue(value)}
      onSearch={debounceSearch}
      onSelect={(value, option) => {
        if (onSelect) onSelect(value, option);
        setValue("");
      }}
      optionLabelProp="value"
      {...props}
    />
  );
};

export default ProductSearch;
